// Vendors
import { connect } from 'react-redux';

// Modules
import { actions, selectors } from 'app-webtech-core';
import { DownaloadAppNotificationComponent } from '../components/DownloadAppNotification';

const mapStateToProps = (state) => {
  const { query } = selectors.location.properties(state);
  const showNotificationForced =
    query && query.app_notification === 'true' && query.embed !== 'true';

  return {
    inWelcomeScreen: selectors.layout.properties(state).showWelcomeScreen,
    getAppBannerDismissed: selectors.application.properties(state).getAppBannerDismissed,
    appLoaded: selectors.application.properties(state).appLoaded,
    marketingRegion: selectors.playbackSession.properties(state).marketingRegion,
    showNotificationForced,
    isEmbed: query ? query.type === 'embed' : false ,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dismissGetAppBanner: () => dispatch(actions.application.dismissGetAppBanner()),
});

export const DownloadAppNotification = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DownaloadAppNotificationComponent);
